import { changeTagName } from './change-tag-name';

export function handleLGPHeadings() {
  const headings = document.querySelectorAll<HTMLHeadingElement>('h1,[data-h1]');

  for (const heading of headings) {
    heading.setAttribute('data-h1', 'true');

    if (isElementVisible(heading)) {
      changeTagName(heading, 'h1');
    } else {
      changeTagName(heading, 'h2');
    }
  }
}

function isElementVisible(element: HTMLElement) {
  let current: HTMLElement | null = element;
  while (current) {
    const style = getComputedStyle(current);
    if (style.display === 'none') {
      return false;
    }
    current = current.parentElement;
  }
  return true;
}
